import { styled, ButtonBase, Typography, Stack } from '@mui/material';

export const GroupContainer = styled('div')(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
}));

export const GroupHeader = styled(ButtonBase, {
  shouldForwardProp: (prop) => prop !== 'hasErrors' && prop !== 'expanded',
})<{ hasErrors: boolean; expanded: boolean }>(
  ({ theme, hasErrors, expanded }) => ({
    width: '100%',
    justifyContent: 'space-between',
    padding: theme.spacing(1, 1.5),
    gap: theme.spacing(1),
    textAlign: 'left',
    borderLeft: `3px solid ${
      hasErrors ? theme.palette.error.main : theme.palette.warning.main
    }`,
    borderTopLeftRadius: 4,
    borderBottomLeftRadius: expanded ? 0 : 4,
  }),
);

export const GroupHeaderInfo = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  minWidth: 0,
  flex: 1,
}));

export const GroupSeverityDot = styled('span', {
  shouldForwardProp: (prop) => prop !== 'hasErrors',
})<{ hasErrors: boolean }>(({ theme, hasErrors }) => ({
  width: 8,
  height: 8,
  borderRadius: '50%',
  flexShrink: 0,
  backgroundColor: hasErrors
    ? theme.palette.error.main
    : theme.palette.warning.main,
}));

export const GroupReference = styled(Typography)({
  fontWeight: 600,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
});

export const GroupMeta = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  whiteSpace: 'nowrap',
}));

export const GroupRows = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(1),
  padding: theme.spacing(1, 1.5, 1.5),
  backgroundColor: theme.palette.action.hover,
  overflow: 'auto',
  maxHeight: 200,
}));

export const GroupRow = styled('div')({
  display: 'flex',
  flexDirection: 'column',
});

export const GroupRowHeader = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontWeight: 600,
}));

export const GroupRowMessage = styled(Typography)({
  wordBreak: 'break-word',
});
